import { HttpClient } from '@opallabs/api'
import loadSlide from '../loadSlide'

const hideSlide = (presentationId, slideId) =>
  HttpClient().delete(
    `/api/v1/presentations/${presentationId}/canvas_slides/${slideId}`
  )

const destroySlide = (presentationId, slideId) => (dispatch) =>
  hideSlide(presentationId, slideId)
    .then((response) => dispatch(loadSlide(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default destroySlide
